import React, { Component } from "react";
import _, { isEmpty, get } from "lodash";
import routes from "../../../../../../routes";
// import { handleFieldError, initializeForm, handleError } from "../../../../../../utils/form-validation";
// import { facebookFormFields } from "./constant";
import { connect } from "react-redux";
// import Input from '../../../../../../components/FormElements/Input';
import {
  getFacebookInfomoAction
} from "../../../../../../actions";
// import { components } from "react-select";
import { withRouter } from "react-router-dom";
// import MySelect from "../../../../../../components/CheckboxSelect";

import asyncRoute from "../../../../../../helpers/hoc/asyncRoute";

import { getTenantCountry } from "../../../../../../selectors";

const ToastModal = asyncRoute(() =>
  import("../../../../../../components/ToastModal")
);

class index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      enableToast: false,
      toastStatus: "",
      toastMsg: "",
      confirmationMsg: "",
    };
  }

  componentWillMount() {
    let isAuthenticated = JSON.parse(localStorage.getItem("AuthData"));
    if (isEmpty(isAuthenticated)) {
      const { history } = this.props;
      history.push(routes.preSignIn);
    }
  }

  confirmationCallbackModel = (id) => {
    // console.log('hello2')
    const { facebookAds, isReloadPage, redirectToList } = this.state;
    const { handleCallback, history } = this.props;
    this.setState({ enableToast: false }, () => {
      history.push(
        "/" +
          routes.mainRoute +
          "/" +
          routes.containers.admin +
          "/" +
          routes.admin.advertiser.newAdvertiser
      );
    });
  };

  handleToastStatus = (status) => {
    const { facebookAds, redirectToList, isReloadPage } = this.state;
    const { handleCallback, history } = this.props;
    this.setState({ enableToast: status }, () => {
      history.push(
        "/" +
          routes.mainRoute +
          "/" +
          routes.containers.admin +
          "/" +
          routes.admin.advertiser.newAdvertiser
      );
    });
  };

  generateInfomoSeat = async () => {
    const { getFacebookInfomoAction, tenantId, authToken, userId, advId } =
      this.props;

    let advCountry = getTenantCountry(advId);

    const params = {
      id:advId,
      country: advCountry,
    };
    const {
      responseCode: { status = "", msg = "", message = "" },
    } = await getFacebookInfomoAction({ tenantId, authToken, userId, params });

    if (status.toLowerCase() == "success") {
      this.setState({
        enableToast: true,
        toastStatus: status,
        toastMsg: msg ? msg : message ? message : "",
      });
    }
    else{
      this.setState({
        enableToast: true,
        toastStatus: status,
        toastMsg: msg ? msg : message ? message : "",
      });
    }
  };

  render() {
    const {
      enableToast = false,
      toastStatus = "",
      toastMsg = "",
      confirmationMsg = "",
    } = this.state;
    const { paths } = this.props;
    return (
      <>
        {enableToast && (
          <ToastModal
            enableToast={enableToast}
            status={toastStatus}
            msg={toastMsg}
            // path={routes.containers.admin + "/" + routes.admin.advertiser.poc}
            idProps={paths}
            handleConfirmation={this.confirmationCallbackModel}
            handleToastStatus={this.handleToastStatus}
            confirmationMsg={confirmationMsg}
            outSideClickEnable={false}
            poc={true}
          />
        )}
        <div className="main-class-wrap text-left">
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => {this.generateInfomoSeat()}}
            style={{ position: "relative" }}
          >
            Generate Account Id
          </button>
        </div>
      </>
    );
  }
}

export default withRouter(
  connect(
    (state) => ({
      tenantId: get(state, "app.preSignInState.tenantId", ""),
      userId: get(state, "app.preSignInData.userId", ""),
      authToken: get(state, "app.signInData.authToken", ""),
    }),
    { getFacebookInfomoAction }
  )(index)
);
